"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _mobileDetectionHelper = _interopRequireDefault(require("../helpers/mobile-detection-helper"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var defaultAnimationwait = 500;

var Portal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Portal);
    _this = _super.call(this, props);

    _this.connectPortalRoot = function () {
      if (_this.portalRoot) {
        if (_this.propExists('style')) {
          _this.portalRoot.style = _this.props.style;
        }

        _this.portalRoot.appendChild(_this.el);

        if (_this.propExists('appendClass')) {
          _this.portalRoot.classList.add(_this.props.appendClass);
        }

        _this.animate(function () {
          return _this.portalRoot.classList.add('animated');
        }, 100);

        _this.animate(function () {
          return _this.toggleWrapper();
        }, defaultAnimationwait);
      }
    };

    _this.state = {};
    _this.el = document.createElement('div');
    _this.createdPortalRoot = false;
    return _this;
  }

  (0, _createClass2["default"])(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.portalRoot = this.props.elementId != null ? this.findPortalRoot() : this.createPortalRoot(); // Create a MutationObserver and wait until the element is available.
      // This is usefull when the Portal is used, but the target element is not available in the DOM yet.

      if (!this.portalRoot && this.props.elementId) {
        var config = {
          childList: true,
          subtree: true
        };
        this.observer = new MutationObserver(function () {
          _this2.portalRoot = _this2.findPortalRoot();

          if (_this2.portalRoot) {
            _this2.connectPortalRoot();

            _this2.observer.disconnect();

            _this2.observer = null;
          }
        });
        this.observer.observe(document.body, config);
      }

      this.connectPortalRoot();
    }
  }, {
    key: "propExists",
    value: function propExists(prop) {
      if (this.props.hasOwnProperty(prop)) {
        return true;
      }

      return false;
    }
  }, {
    key: "toggleWrapper",
    value: function toggleWrapper() {
      if (!(0, _mobileDetectionHelper["default"])()) {
        return false;
      }

      if (this.props.hideBody) {
        var dom = document.getElementsByClassName('app-wrapper-body')[0];
        dom && dom.classList.toggle('hidden');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Clean up the MutationObserver
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      } // TODO: This is not animated currently, should be fixed by using a
      // ReactCSSTransitionGroup wont work now because of unmounting


      if (this.portalRoot) {
        this.toggleWrapper();
        this.portalRoot.classList.remove(this.props.appendClass);
        this.portalRoot.classList.remove('animated');
        this.portalRoot.removeChild(this.el);

        if (this.createdPortalRoot) {
          this.portalRoot.remove();
          this.portalRoot = null;
          this.createdPortalRoot = false;
        }
      }
    }
  }, {
    key: "animate",
    value: function animate(func, sec) {
      setTimeout(func, sec);
    }
  }, {
    key: "render",
    value: function render() {
      return (0, _reactDom.createPortal)(this.props.children, this.el);
    }
  }, {
    key: "findPortalRoot",
    value: function findPortalRoot() {
      return document.getElementById(this.props.elementId);
    }
  }, {
    key: "createPortalRoot",
    value: function createPortalRoot() {
      var portal = document.createElement('div');
      document.body.appendChild(portal);
      this.createdPortalRoot = true;
      return portal;
    }
  }]);
  return Portal;
}(_react["default"].Component);

Portal.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].element), _propTypes["default"].element]),

  /**
   * Provide this if the portal should correspond to a specific location in the DOM.
   * If omitted, a portal will be created as a direct descendant of <body>.
   */
  elementId: _propTypes["default"].string,
  hideBody: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  appendClass: _propTypes["default"].string
};

var requiresDocument = function requiresDocument(Component) {
  return function (props) {
    return document != null && /*#__PURE__*/_react["default"].createElement(Component, props);
  };
};

var _default = requiresDocument(Portal);

exports["default"] = _default;